import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetSpeciesesInputDto, SpeciesCreateDto, SpeciesDto, SpeciesExcelDownloadDto, SpeciesUpdateDto } from '../dtos/species/models';

@Injectable({
  providedIn: 'root',
})
export class SpeciesService {
  private restService = inject(RestService);
  apiName = 'General';
  

  create = (input: SpeciesCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesDto>({
      method: 'POST',
      url: '/api/general/specieses',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/general/specieses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/general/specieses',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesDto>({
      method: 'GET',
      url: `/api/general/specieses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/general/specieses/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetSpeciesesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<SpeciesDto>>({
      method: 'GET',
      url: '/api/general/specieses',
      params: { speciesGroupId: input.speciesGroupId, speciesGroupName: input.speciesGroupName, genusId: input.genusId, name: input.name, remsoftSpeciesGroupId: input.remsoftSpeciesGroupId, remsoftSpeciesGroupName: input.remsoftSpeciesGroupName, logisticsSpeciesGroupId: input.logisticsSpeciesGroupId, logisticsSpeciesGroupName: input.logisticsSpeciesGroupName, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: SpeciesExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/general/specieses/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, speciesGroupId: input.speciesGroupId, speciesGroupName: input.speciesGroupName, genusId: input.genusId, name: input.name, remsoftSpeciesGroupId: input.remsoftSpeciesGroupId, remsoftSpeciesGroupName: input.remsoftSpeciesGroupName, logisticsSpeciesGroupId: input.logisticsSpeciesGroupId, logisticsSpeciesGroupName: input.logisticsSpeciesGroupName, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesDto[]>({
      method: 'GET',
      url: '/api/general/specieses/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: SpeciesUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SpeciesDto>({
      method: 'PUT',
      url: `/api/general/specieses/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}